module.exports = __webpack_public_path__ + "static/media/btn_login_base.0e6ddff0.png";